module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9InV0aWxpdHkvY2FsZW5kYXIiPgo8cGF0aCBpZD0ic3Ryb2tlIiBkPSJNMjIgOFYyLjgxODI5SDE3LjVNMjIgOFYyMUgyVjhNMjIgOEgyTTIgOFYyLjgxODI5SDYuNU0xMCA0LjYzNjM0VjFNMTQgNC42MzYzNFYxIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon_calendar.svg
// module id = iWp6
// module chunks = 1